{% block swag_cms_extensions_form_element_email %}
    <mt-email-field
        :modelValue="displayValue"
        :label="field.translated ? field.translated.label : field.label"
        :required="field.required"
        :disabled
    />
{% endblock %}
